/**
 * 重新分页
 */
import {useState, useEffect} from 'react';
import * as store from '@/store';
import {getMorphoService, serviceNames} from '@/rte/editor';
import RePageinate from '@/assets/svg/ai/rePageinate.svg?tsx';
import toast, {ToastType} from '@/components/Toast';
import sdk from '@/sdk';

import styles from './index.module.scss';
import {GRAY_RELEASE_KEYS, initGray} from '@/grayRelease';

interface IProps {
    isHover: boolean;
    docGuid: string;
    showSlideCover?: boolean;
    isCardView?: boolean;
}

const RePaginate: React.FC<IProps> = ({isHover, docGuid, showSlideCover = true, isCardView = false}) => {
    const [guideVisible, setGuideVisible] = useState(false);
    const [isShowEntry, setIsShowEntry] = useState(false);

    const {
        useIsInGray: newReslideParams,
    } = initGray(GRAY_RELEASE_KEYS.newReslideParams);

    const isNewReslideParams = newReslideParams();

    const handleClick = async () => {
        try {
            const testConfig = getMorphoService(serviceNames.ICardService);
            if (testConfig && testConfig.reSlide) {
                const reSlideParams = isNewReslideParams ? {ignoreAvoidCardBreak: true} : {};
                testConfig.reSlide({
                    ...reSlideParams,
                    source: 'title',
                });
                toast({
                    content: '已重新分页',
                    duration: 3000,
                    type: ToastType.Success,
                });
            }
        }
        catch (error) {
            console.error(error, '------');
        }
    };

    useEffect(() => {
        if (!window.isTocPage) {
            setTimeout(() => {
                setGuideVisible(!sdk.as.user?.settings?.newGuide?.hideHeaderImage && !showSlideCover);
            }, 100);
        }
    }, [showSlideCover]);

    useEffect(() => {
        if (guideVisible && !showSlideCover) {
            setIsShowEntry(true);
        } else {
            setIsShowEntry(!showSlideCover && isCardView && isHover);
        }

    }, [showSlideCover, isCardView, guideVisible, isHover]);

    return (
        <div className={styles.wrapperBox}>
            {isShowEntry && (
                <div className={styles.wrapper} onClick={handleClick}>
                    <RePageinate className={styles.icon} />
                    <div className={styles.text}>重新分页</div>
                </div>
            )}
        </div>
    );
};

export default store.connect([
    store.KEYS.SHOW_SLIDE_COVER,
])(RePaginate);
